import React, { useRef, useState } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

import useUiuxStore from "src/store/useUiuxStore";


import { useMouseContent } from "src/utils/mouse/mouseContent";

import { Content_MST3020_R01 } from "./Content_MST3020_R01";
import { SearchSection_MST3020_R01 } from "./SearchSection_MST3020_R01";
import { useMST3020_R01Store } from "./Store_MST3020_R01";
import { AgGridReact } from "ag-grid-react";
import { MST3020_R01DetailDto, MST3020_R01Dto, MST3020_R01HeaderDto } from "./Dto_MST3020_R01";
import { Table_MST3020_R01 } from "./Table_MST3020_R01";
import { DetailTable_MST3020_R01 } from "./DetailTable_MST3020_R01";
import { Info_MST3020_R01 } from "./Info_MST3020_R01";


export const Container_MST3020_R01 = () => {

	const { 
	} = useMST3020_R01Store();

	const { moneyCdList, vatTypeList } = useCommonCodeStore();
	const { tabList, setMessage } = useUiuxStore();

	const RESIZER = {
		code: 'MST3020_R01',
		type: 'width',
		storageKey: 'MST3020_R01-split-width',
		min: 5,
		max: 80,
		default: 35
	} as const;
	const gridRef = useRef<AgGridReact<MST3020_R01HeaderDto>>(null);
	const detailGridRef = useRef<AgGridReact<MST3020_R01DetailDto>>(null);

	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	

	const { 
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef
	});

	const V_RESIZER = {
		code: 'MST3020_R01',
		type: 'height',
		storageKey: 'MST3020_R01-info-split-height',
		min: 5,
		max: 80,
		default: 40
	} as const;
	const rightTopRef = useRef<HTMLDivElement>(null);
	const isVResizing = useRef(false);

	const { 
		splitValue: vSplitValue,
		handleMouseDown: handleVMouseDown,
	} = useMouseContent({
		resizer: V_RESIZER,
		isResizing: isVResizing,
		containerRef: infoRef,
		infoRef: rightTopRef
	});

	const {
		handlePrintClick,
		handleExcelClick,
		fetchData,
		defaultMST3020_R01DetailRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
	} = Content_MST3020_R01({
		gridRef,
		detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
		
	});

	return <div className={`content-container`}>
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleCreateClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onPrintClick={handlePrintClick}
			onExcelClick={handleExcelClick}
			onInitClick={initContainerData}
		/>
		<SearchSection_MST3020_R01 />

		<div className="flex flex-1 p-[12px] gap-[4px] min-h-0"
			ref={containerRef}>
			<div className="h-full" style={{ width: `${splitValue}%` }}>
				<Table_MST3020_R01 gridRef={gridRef} />
			</div>
			{/* 리사이저 */}
			<div
				className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
				onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('LR', e.nativeEvent)}
				data-comment="리사이저"
			/>
			<div className="h-full flex flex-col gap-[4px]" style={{ width: `${100 - splitValue}%` }} ref={infoRef}>
				<div style={{ height: `${vSplitValue}%`, maxHeight: `${vSplitValue}%` }} ref={rightTopRef}>
					<DetailTable_MST3020_R01 gridRef={detailGridRef} defaultMST3020_R01DetailRow={defaultMST3020_R01DetailRow()} />
				</div>
				{/* 리사이저 */}
				<div
					className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300 mt-[4px]"
					onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleVMouseDown("UD", e.nativeEvent) }
				/>
				<div style={{ height: `${100 - vSplitValue}%` }}>
					<Info_MST3020_R01 />
				</div>
			</div>
		</div>
		<Message />
	</div>
}
